import { render, staticRenderFns } from "./inbound-sms-completed-icon.vue?vue&type=template&id=3fb099ab"
import script from "./inbound-sms-completed-icon.vue?vue&type=script&lang=js"
export * from "./inbound-sms-completed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports